import React from "react";
import { VariableSizeGrid as Grid } from "react-window";

const LazyLoadTable = ({ data, columns, width, positionIcon }) => {
  const Cell = ({ columnIndex, rowIndex, style }) => (
    <div
      style={{
        ...style,
      }}
      className="rounded"
    >
      <div className="py-5 text-[#848484] flex items-center gap-4 md:gap-8">
        {data[rowIndex][columns[columnIndex]]}
        {columnIndex === 0 && (
          <>
            {positionIcon(data[rowIndex]["position"]) ? (
              <img
                src={positionIcon(data[rowIndex]["position"])}
                alt=""
                className="w-4 object-cover"
              />
            ) : null}
          </>
        )}
      </div>
    </div>
  );

  const getColumnWidth = () => {
    // Adjust column widths as needed
    if (width && window.innerWidth > 768) {
      return width / columns.length;
    }
    return 150;
  };

  const getRowHeight = () => {
    // Adjust row height as needed
    return 50;
  };

  return (
    <>
      <div className="bg-[#F4F4F4] rounded py-5 px-4 w-full overflow-x-auto flex flex-nowrap lg:grid lg:grid-cols-5">
        {columns.map((column, columnIndex) => (
          <div
            style={{
              width: `${getColumnWidth()}px`,
            }}
            key={columnIndex}
            className="whitespace-nowrap px-4 capitalize md:text-sm text-xs font-normal "
          >
            {column}
          </div>
        ))}
      </div>

      <Grid
        columnCount={columns.length}
        columnWidth={getColumnWidth}
        height={400}
        rowCount={data.length} // +1 for header row
        rowHeight={getRowHeight}
        width={width} // Set width to 100% or adjust as needed
        className="scroller_ md:mx-6 mx-4"
      >
        {Cell}
      </Grid>
    </>
  );
};

export default LazyLoadTable;
